import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdvanceSalary from './AdvanceSalary';
import {advanceSalaryListingRequest, advanceSalaryCalculateRequest, advanceSalaryUpdateRequest} from "services/redux/Valet/Project/action";

const mapStateToProps = (state) => ({
    advanceSalaryListResponse: state.CreateProject.advanceSalaryListResponse,
    advanceSalaryCalculateResponse: state.CreateProject.advanceSalaryCalculateResponse,
    advanceSalaryUpdateResponse: state.CreateProject.advanceSalaryUpdateResponse
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        advanceSalaryListingRequest,
        advanceSalaryCalculateRequest,
        advanceSalaryUpdateRequest
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(AdvanceSalary);
